import React, { useState } from "react";

export default function MenuV2() {
    return (
        <div className="styles_LeftPanel__j42hT">

            <LeftItem
                href="/products"
                label="Tất Cả Sản Phẩm"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/202506789dbb6648c471cb21a9ed304dtatcasp.svg"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20250ce46c2ec9f3b298dbe5d04932b0tatcasanpham_active.svg"
            />

            <LeftItem
                href="/products?tag=32U1"
                label="Thuốc Kê Đơn"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2025c361d66b458e3399de762467f460thuockedon_inactive.svg"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/2025af535ce49d7dc329dd5731ebb3e7thuockedon_active.svg"
                hasSub
            />

            <LeftItem
                href="/products?tag=A4DX"
                label="Thuốc Không Kê Đơn"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20259673c0bcaa15f1083569720ae70ethuoc0kedon_active2.svg"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/202509d02932b0119233d9d68f71b0a6thuockhongkedon.svg"
                hasSub
            />

            <LeftItem
                href="/products?tag=VDCL"
                label="Thực Phẩm Chức Năng"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20257bb04ed2750c5ca9ad4e8f2d72c0thucphamchucnang2_active.svg"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/20259a3998af0979ca2af9fd37125b7athucphamchucnang.svg"
                hasSub
            />

            <LeftItem
                href="/products?tag=XGQD"
                label="Dược Mỹ Phẩm"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20259aed5ac14159896524569c6cbe54duocmypham_active.svg"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2025c9d40edfb19bb493454ee4ab9031duocmypham.svg"
                hasSub
            />

            <LeftItem
                href="/products?tag=B70T"
                label="Thiết Bị & Vật Tư Y Tế"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2025e4051fe2b60fc999657422ff565ethietbiyte.svg"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20253bb27284ded25c2bf69bd1b96e72thietbiyte_active.svg"
                hasSub
            />

            <LeftItem
                href="/products?tag=C81Y"
                label="Hàng Tiêu Dùng"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20255e28d64a7299d52deebf83dbf906hangtieudung_2acitve.svg"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2025a2b56fe9c25066c7cd158fe11847hangtieudung.svg"
                hasSub
            />

            <LeftItem
                href="/products?tag=XX4A"
                label="Buymed Tuyển Chọn"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/20255f53c765d7b884b0cb65fea25346buymed_active.svg"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/202549462c469e209ee3256e88faf1fdbuymedtuyenchon.svg"
                badge="https://gcs.buymed.com/thuocsi-live/internal/cms/20250ca5cfbcf070784ad8dff2af973abadge_icon.svg"
            />

            <LeftItem
                href="/products?tag=ECLT&currentTab=combo-uu-dai&page=1"
                label="Combo Ưu Đãi"
                iconActive="https://gcs.buymed.com/thuocsi-live/internal/cms/2025c3533a17f3f0833bee2d15fdd736combo_active.svg"
                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2025dd5b281edd5a06d03c046ab11fb2combouudai.svg"
                badge="https://gcs.buymed.com/thuocsi-live/internal/cms/20256324d851532a7ef2809f43dde97bbadge_icon.svg"
            />

        </div>
    );
}

/* ================= ITEM ================= */

function LeftItem({
    href,
    icon,
    iconActive,
    label,
    active,
    hasSub,
    badge,
}: {
    href: string;
    icon: string;
    iconActive?: string;
    label: string;
    active?: boolean;
    hasSub?: boolean;
    badge?: string;
}) {
    const [hovered, setHovered] = useState(false);

    const currentIcon =
        (hovered || active) && iconActive ? iconActive : icon;

    return (
        <div>
            <a
                href={href}
                className={[
                    "styles_LeftPanelItem__l4X_d",
                    active && "styles_LeftPanelItemActive__VTo7C",
                    hasSub && "styles_LeftPanelItemWithSubItems__bXX8R",
                ]
                    .filter(Boolean)
                    .join(" ")}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <div className="styles_LeftPanelItemContent__iJGN4">
                    <div className="styles_LeftPanelIcon__r4TtA">
                        <span
                            style={{
                                boxSizing: "border-box",
                                display: "inline-block",
                                overflow: "hidden",
                                position: "relative",
                                maxWidth: "100%",
                            }}
                        >
                            <span>
                                <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20version='1.1'%20width='24'%20height='24'/%3e"
                                />
                            </span>

                            <img
                                alt={label}
                                src={currentIcon}
                                decoding="async"
                                data-nimg="intrinsic"
                                style={{
                                    opacity: 1,
                                    transition: "opacity 0.2s ease-in-out",
                                    position: "absolute",
                                    inset: 0,
                                    margin: "auto",
                                    display: "block",
                                    width: 0,
                                    height: 0,
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                }}
                            />
                        </span>
                    </div>

                    <div className="styles_LeftPanelLabel__k8uR2">
                        <span>{label}</span>

                        {badge && (
                            <span className="styles_BadgeIcon__CBDxU inline-block">
                                <img alt="badge" src={badge} />
                            </span>
                        )}
                    </div>
                </div>
            </a>
        </div>
    );
}
